export default "__VITE_ASSET__D6dFW1py__"